
<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-3 lg:gap-6">
        <div
            v-for="i in 2"
            :key="i"
            class="bg-gray-200 rounded-md w-full h-[200px] md:h-auto shadow-md skeleton-animation"
        ></div>
    </div>
</template>